import { MaybeRefOrGetter } from '@vueuse/core'
import { ref, toValue } from 'vue'
import { Model } from '../types'
import { CollectionResponse } from '../types/CollectionResponse'

export interface UseQTablePaginator {
  rowsPerPage: MaybeRefOrGetter<number>
  sortBy: MaybeRefOrGetter<string>
  descending: MaybeRefOrGetter<boolean>
  page: MaybeRefOrGetter<number>
  rowsNumber: MaybeRefOrGetter<number>
}

export default function useQTablePaginator (optionsParam: UseQTablePaginator) {
  const pagination = ref<UseQTablePaginator>({
    sortBy: toValue(optionsParam.sortBy),
    descending: toValue(optionsParam.descending),
    page: toValue(optionsParam.page),
    rowsPerPage: toValue(optionsParam.rowsPerPage),
    rowsNumber: toValue(optionsParam.rowsNumber),
  })

  function setPaginationFromOrionResponse (data: CollectionResponse<Model>) {
    pagination.value.page = data.meta.current_page
    pagination.value.rowsPerPage = data.meta.per_page
    pagination.value.rowsNumber = data.meta.total
  }

  return {
    pagination,
    setPaginationFromOrionResponse,
  }
}
